import React from 'react'
import { AnimatePresence, motion } from 'motion/react'
import { DiamondsFour, Gear, Question } from '@phosphor-icons/react'
import { IconButton } from '@shopflo/ui'
import { useRouter } from 'next/router'
import useNavigation from 'src/lib/hooks/useNavigation'
import { classNames } from 'src/lib/utils/helpers'
import BillingWidget from 'src/components/billing/BillingWidget'
import ClosedNavFooter from './nav-footer/CloseNavFooter'
import { useLocale } from 'src/lib/hooks/useLocal'
import { isPathActive } from 'src/lib/utils/path-matching'
import { useUser } from 'src/lib/contexts/UserContext'
import { permissionType } from 'src/lib/utils/constants'
import { useMerchant } from 'src/lib/contexts/MerchantContext'

const NavigationFooter = () => {
  const router = useRouter()
  const {
    getters: { sidebarOpen },
    actions: { resetAndRedirect }
  } = useNavigation()

  const { canAccess, isUserConfigured } = useUser()

  const { t } = useLocale()

  const {
    getters: { merchant }
  } = useMerchant()

  return (
    <div className='flex flex-col gap-2 mt-auto w-full '>
      <div className='border-t-1 border-gray-200 w-full'>
        {sidebarOpen ? (
          <AnimatePresence>
            <motion.div
              className='h-full w-full p-2 flex flex-col gap-2'
              layout
              initial={{ opacity: 0, x: 0, filter: 'blur(8px)' }}
              animate={{ opacity: 1, x: 0, filter: 'blur(0px)' }}
              exit={{ opacity: 0, y: 0, filter: 'blur(8px)' }}
              transition={{ duration: 0.3 }}
            >
              <motion.button
                layout
                onClick={() => resetAndRedirect('/apps-integrations')}
                className={classNames(
                  'relative flex w-full items-center rounded-md transition-colors px-1 py-1 hover:bg-black/5 h-[28px] align-center justify-center disabled:opacity-50 disabled:cursor-not-allowed',
                  isPathActive(router.pathname, '/apps-integrations')
                    ? 'bg-white shadow-[0_0_0_0.5px_rgba(54,65,83,0.06),0_0.5px_1px_0_rgba(54,65,83,0.20)]'
                    : ''
                )}
                id='apps-store'
                disabled={!canAccess(permissionType.TAB_APP_STORE, 0) || !isUserConfigured}
              >
                <motion.div layout className='grid  w-[28px] place-content-center text-lg  justify-center items-center'>
                  <DiamondsFour size={18} className='text-zinc-600' />
                </motion.div>
                {sidebarOpen && (
                  <>
                    <motion.span layout className='text-text-sm-medium flex items-center  px-1 flex-1'>
                      {t('apps_integrations')}
                    </motion.span>
                  </>
                )}
              </motion.button>

              <div className='flex items-center justify-between '>
                <motion.div>
                  <BillingWidget />
                </motion.div>

                <div className='flex items-center gap-1'>
                  <div onClick={() => resetAndRedirect('/settings')} id='settings'>
                    <IconButton
                      variant='ghost'
                      size='sm'
                      IconComponent={Gear}
                      tooltip={{ text: t('settings'), side: 'top', sideOffset: 1 }}
                      className={classNames(
                        'bg-gray-100 hover:bg-gray-200',
                        isPathActive(router.pathname, '/settings') ? 'bg-white' : ''
                      )}
                      disabled={!canAccess(permissionType.TAB_SETTINGS, 0) || !isUserConfigured}
                    />
                  </div>
                  <div onClick={() => resetAndRedirect('/support')} id='support'>
                    <IconButton
                      variant='ghost'
                      size='sm'
                      IconComponent={Question}
                      tooltip={{ text: t('support'), side: 'top', sideOffset: 1 }}
                      className={classNames(
                        'bg-gray-100 hover:bg-gray-200',
                        isPathActive(router.pathname, '/support', true) ? 'bg-white' : ''
                      )}
                      disabled={!canAccess(permissionType.TAB_SUPPORT, 0) || !isUserConfigured}
                    />
                  </div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        ) : (
          <ClosedNavFooter />
        )}
      </div>
    </div>
  )
}

export default NavigationFooter
